import { APIPath } from '../constant'
import { CommonUtility } from '../common'
import { BaseService } from './base'

class TaskDashboard {
    getStats(queryParams = {}) {
        const params = CommonUtility.objectToParams(queryParams)
        const suffix = params ? `?${params}` : ''
        return BaseService.get(`${APIPath.dashboardStats}${suffix}`)
    }

    getTasks(queryParams = {}) {
        const params = CommonUtility.objectToParams(queryParams)
        const suffix = params ? `?${params}` : ''
        return BaseService.get(`${APIPath.dashboardTasks}${suffix}`)
    }

    getFullPreview(taskId) {
        return BaseService.get(
            `${APIPath.dashboardTaskFullPreview}${taskId}/FullPreview`,
        )
    }
}

const TaskDashboardService = Object.freeze(new TaskDashboard())
export { TaskDashboardService }
